import { h, Component, Fragment } from "preact";
import PropTypes from "prop-types";
import { isEmpty, sendRequest } from "../../tools";

export default class MeterReading extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    onSaved: PropTypes.func.isRequired,
    contractId: PropTypes.string,
    meterDevices: PropTypes.array,
    regPointId: PropTypes.string,
    reading: PropTypes.boolean,
  };

  constructor(props) {
    super(props);
    this.state = {
      readings: {},
      loading: false,
      saved: false,
      errors: null,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.meterDevices !== this.props.meterDevices) {
      this.setState({
        readings: {},
        loading: false,
        saved: false,
        errors: null,
      });
    }
  }

  render(props, state, context) {
    const errors = { ...state.errors };
    if (props.meterDevices.length === 0) {
      return;
    }

    return (
      <div className="form-block__section form-block__section_pdt_none form-block__section_mgt_none">
        <div className="modal-2__section-inner">
          <fieldset className="form__fieldset">
            <div className="counter-form-section">
              <div className="counter-form-section__row">
                <div className="counter-form-section__left">
                  {props.meterDevices.map((item) => {
                    return (
                      <div className="counter-form-section__item">
                        <div className="counter-form-section__counter-wrapper">
                          <div className="counter-form-section__counter-title">
                            Прибор учета
                          </div>
                          <div className="counter-form-section__counter">
                            {props.regPointId}
                          </div>
                        </div>
                        <div className="counter-form-section__field-wrap">
                          <div className="counter-form-section__testimony-field">
                            <div className="counter-form-section__testimony-title">
                              Текущие значения
                            </div>
                            <input
                              className="counter-form-section__testimony-value input input_bgc_ui-2"
                              value={state.readings[item.number]}
                              type="text"
                              onchange={this.onInputChange(item.number)}
                            />
                            {!!errors &&
                              Object.keys(errors).map((errorField) => {
                                if (
                                  errorField ===
                                    "readings[" + item.number + "]" ||
                                  errorField === "devices[" + item.number + "]"
                                ) {
                                  const currentError = errors[errorField];
                                  delete errors[errorField];
                                  return (
                                    <p className="form__error-text">
                                      {currentError}
                                    </p>
                                  );
                                }
                              })}
                          </div>
                          <div className="counter-form-section__testimony-field">
                            <div className="counter-form-section__testimony-title">
                              Предыдущие значения
                            </div>
                            <div className="counter-form-section__testimony-value">
                              <div className="counter-form-section__testimony-value-line">
                                <div className="counter-form-section__testimony-count">
                                  {item.meterReading}
                                </div>
                                <div className="counter-form-section__testimony-date">
                                  от {item.dateMeterReading}
                                </div>
                              </div>
                              <div className="counter-form-section__testimony-value-line">
                                <div className="counter-form-section__testimony-tariff">
                                  Тариф: {item.rate}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="counter-form-section__right">
                  {props.reading ? (
                    <div className="counter-form-section__success-text">
                      Показания успешно внесены
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="counter-form-section__button button-primary button-primary_bgc_brand-2"
                      onclick={this.onSendClick}
                    >
                      Передать показания
                    </button>
                  )}
                </div>
              </div>
            </div>
          </fieldset>
          {!!errors &&
            Object.keys(errors).map((errorField) => (
              <p className="form__error-text">{errors[errorField]}</p>
            ))}
        </div>
      </div>
    );
  }
  send() {
    const self = this;
    const props = this.props;
    const state = this.state;

    if (isEmpty(state.readings)) {
      self.setState({ errors: { readings: "Необходимо ввести показания" } });
      return;
    }

    const url = props.url + "?contractId=" + props.contractId;
    self.setState({
      loading: true,
      errors: null,
    });

    sendRequest(url, {
      type: "POST",
      body: {
        EnterMeterReadings: { readings: state.readings },
      },
    })
      .then((response) => {
        const newState = {
          loading: false,
        };
        switch (response.status) {
          case 200:
            if (response.data.result === "ok") {
              if (props.onSaved && typeof props.onSaved === "function") {
                props.onSaved(props.contractId);
              }
            } else {
              newState.errors = response.data.errors;
            }
            break;
          case 500:
            $.disMsg(
              "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
              { type: "false" }
            );
            break;
          default:
            if (!!response.data && !!response.data.message) {
              newState.errors = [{ message: response.data.message }];
            } else
              throw new Error(
                `Status ${response.status}. Status text: ${response.statusText}`
              );
        }

        self.setState(newState);
      })
      .catch((error) => {
        self.setState({ loading: false });
        alert(error);
      });
  }

  onSendClick = (ev) => {
    this.send();
  };
  onInputChange = (number) => (ev) => {
    const readings = this.state.readings;

    if (ev.target.value.length === 0) delete readings[number];
    else readings[number] = ev.target.value;

    this.setState({ readings: readings });
  };
}
